export const PARTICIPANT_TYPE_ID = {
    BORROWER: 1,
    GUARANTOR: 2,
    ASSIGNOR: 3,
    'GUARANTOR-RETAIL': 4,
    RECIPIENT: 5,
    BUSINESS_PARTNER: 7,
} as const satisfies Record<string, number>;

export type ParticipantTypeId = typeof PARTICIPANT_TYPE_ID[keyof typeof PARTICIPANT_TYPE_ID];
